import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

@Injectable()
export class LoginGuard implements CanActivate {

  // usamos este guard para redireccionar el login a Angular 13 en caso de NO estar en localhost
  // TODO: este check debe hacerse sobre el environment y no sobre el URL

  constructor( private router: Router ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!location.href.includes('localhost')) {
      window.open(environment.EXTERNAL_BASE_URL.split('v2')[0] + 'v2/login', '_self');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/guards/login/login.guard.ts